// src/modules/clinical-note-ai/services/clinicalNoteAiService.js

import { uploadFileToOpenAI, callOpenAIResponses } from '../../../utils/services/openaiClient';
import { safeParseJsonFromModel } from '../utils/safeParseJsonFromModel';
import { DEFAULT_ANALYSIS } from '../constants/analysisSchema';
import { buildClinicalNotePrompt } from '../constants/prompts';

export const analyzeClinicalPdfWithAI = async ({ file, model = 'gpt-4o-mini' }) => {
  if (!file) throw new Error('No PDF file provided');

  // 1) Upload → file_id
  const uploaded = await uploadFileToOpenAI(file);
  const fileId = uploaded?.id;

  if (!fileId) throw new Error('OpenAI file upload did not return an id');

  // 2) Responses input (texto + archivo)
  const prompt = buildClinicalNotePrompt();

  const input = [
    {
      role: 'user',
        content: [
        { type: 'input_text', text: prompt },
        { type: 'input_file', file_id: fileId },
        ],
    },
  ];

  const resp = await callOpenAIResponses({ model, input });

  // 3) Extraer texto del output (Responses puede venir en varias partes)
  // Intentamos recoger el texto de manera robusta.
  const outputText =
    resp?.output_text ||
    resp?.output?.[0]?.content?.map((c) => c?.text).filter(Boolean).join('\n') ||
    '';

  if (!outputText) {
    console.error('[analyzeClinicalPdfWithAI] Empty output:', resp);
    throw new Error('Empty response from OpenAI');
  }

  // 4) Parse JSON y merge con defaults
  try {
    const json = safeParseJsonFromModel(outputText);
    return { ...DEFAULT_ANALYSIS, ...json };
  } catch (e) {
    console.error('[analyzeClinicalPdfWithAI] JSON parse failed:', e, outputText);
    return { ...DEFAULT_ANALYSIS, summary: 'Failed to parse model JSON output.' };
  }
};
